<script setup>
import SubscriptionDialog from './SubscriptionDialog.vue';
import { ref, defineExpose } from 'vue';
import { useCommonData } from '@/hooks';
import i18n from '@/locales';

const dialogCtx = ref(null);
const { generateMobileModuleUrl } = useCommonData();
const open = ({ mode }) => {
	if (mode === 'mobile') {
		const url = generateMobileModuleUrl('message_subscription', { f: 'PC' });
		window.open(url, '_blank');
		return;
	}
	dialogCtx.value?.open();
};
defineExpose({ open });
</script>

<template>
	<SubscriptionDialog ref="dialogCtx" :key="i18n.locale" />
</template>

<style lang="less" scoped></style>
